import { Guide, Ticket, User } from "@/api/types";

export const siteKey = '6Lf8EMwcAAAAAAtmJVt2BftFVBh2sbEi_Lt_5ty2';
export const env: 'development' | 'production' = process.env.NODE_ENV ?? 'production'
export const baseURL = env === 'development' ? 'http://localhost:8000/' : '/'

export const apiBase: string = baseURL + 'api/';
export const blankTicket: Ticket = {
    id: -1,
    state: -1,
    created_at: '',
    owner: {
        id: -1,
        username: '',
        access: -2
    },
    assigned: {
        id: -1,
        username: '',
        access: -2
    },
    title: '',
    category: -1,
    body: ''
}
export const blankUser: User = {
    id: -1,
    username: '',
    email: '',
    email_verified_at: null,
    hwid: '',
    started: false,
    connected: false,
    last_hwid_change: null,
    access: -2,
    owned: false,
    owned_advanced: false,
    department: -1,
    discord: null,
    owned_expires_at: null,
    owned_advanced_expires_at: null,
    created_at: null,
    updated_at: null,
    ips: [],
    message: null,
    referral: null,
    tickets: [],
    ban_appeals: [],
}
export const blankGuide: Guide = {
    id: -1,
    title: '',
    body: [],
    type: '',
    staff_only: false,
    support_enabled: false,
}

if (env === 'development') {
    console.log('%c Dream is running in development mode', "background: black; color: white; padding: 1em")
} else {
    console.log('%cWarning', 'padding: .25em; background: #f13a3a; font-size: 2em')
    console.log(`%cDream is a closed source application attempting to reverse engineer,
crack, pirate or any other attempts at modification are against our
TOS and may result in the removal of your product`,
        "background: black; padding: 1em");
}
console.log('Copyright © 2019 - ' + new Date().getFullYear() + ' Dream All Right Reserved ')


export const categoryNames = [
    'Technical Support',
    'Sales',
    'Detections',
    'Suggestions',
    'Media Application',
    'Other'
];

export const stateNames = [
    'Open',
    'Closed',
    'Locked'
];

export const roleNames = [
    'Default',
    'Media',
    'Helper',
    'Admin',
    'Super-Admin'
];

export const envMessages: { [key: string]: { title: string, text: string, env: string } } = {
    'referral_percent': {
        title: 'Update Referral Percent',
        text: 'Please enter the new referral price increment',
        env: 'REFERRAL_PRICE_PERCENT'
    },
    'referral_min': {
        title: 'Update Referral Minimum',
        text: 'Please enter the new minimum referral withdraw amount',
        env: 'REFERRAL_PRICE_MIN'
    },
    'discord': {
        title: 'Update Discord',
        text: 'Please enter the new discord link below',
        env: 'DISCORD_LINK'
    },

    'version_basic': {
        title: 'Set  Version',
        text: 'Please enter the new version number below',
        env: 'APP_VERSION'
    },
    'version_advanced': {
        title: 'Set Version',
        text: 'Please enter the new version number below',
        env: 'APP_VERSION_ADVANCED'
    },
    'lifetime_basic': {
        title: 'Set Lifetime Price',
        text: 'Please enter the new lifetime price below DONT INCLUDE dollar sign format as such: 35.00',
        env: 'PRICE_LIFETIME'
    },
    'monthly_basic': {
        title: 'Set Monthly Price',
        text: 'Please enter the new monthly price below DONT INCLUDE dollar sign format as such: 9.00',
        env: 'PRICE_MONTHLY_BASE'
    },
    'monthly_incr': {
        title: 'Set Monthly Price Increment',
        text: 'Please enter the new monthly price increment below DONT INCLUDE dollar sign format as such: 5.00',
        env: 'PRICE_MONTHLY_BULK_INCR'
    },
    'lifetime_advanced': {
        title: 'Set Lifetime Price',
        text: 'Please enter the new lifetime price below DONT INCLUDE dollar sign format as such: 35.00',
        env: 'PRICE_ADVANCED_LIFETIME'
    },
    'monthly_advanced': {
        title: 'Set Monthly Price',
        text: 'Please enter the new monthly price below DONT INCLUDE dollar sign format as such: 9.00',
        env: 'PRICE_ADVANCED_MONTHLY'
    }
}
